<genealogy-chart [genealogies]="genealogies" [genealogyChartConfig]="genealogyChartConfig"></genealogy-chart>
